import React, { DetailedHTMLProps } from 'react'
import styles from './InfoCard.module.scss'
import CardUi from '@components/ui/Card/CardUi'
import { Spin } from 'antd'
import { antIcon } from '@components/TopUsers/TopUsers'
import cn from 'classnames'

interface IPropsWithChild {
  children: JSX.Element
  isLoading?: boolean
  className?: any
}

type CustomDivProps = IPropsWithChild &
  DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>

const InfoCard: React.FC<CustomDivProps> = ({
  children,
  className,
  isLoading = false,
  ...props
}) => {
  return (
    <CardUi className={cn(className, styles.container)} {...props}>
      <>{isLoading ? <Spin indicator={antIcon} className={styles.loadSpin} /> : children}</>
    </CardUi>
  )
}

export default InfoCard
